var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconValidatie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.497,
    height: 18.497,
    viewBox: "0 0 19.497 18.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-validatie",
    transform: "translate(15496.747 23328.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.75,1.5H.75A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0h10a.755.755,0,0,1,.75.75A.755.755,0,0,1,10.75,1.5Z",
    transform: "translate(-15488.75 -23312.25)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M10.75,1.5H.75A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0h10a.755.755,0,0,1,.75.75A.755.755,0,0,1,10.75,1.5Z",
    transform: "translate(-15488.75 -23319.25)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M10.75,1.5H.75A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0h10a.755.755,0,0,1,.75.75A.755.755,0,0,1,10.75,1.5Z",
    transform: "translate(-15488.75 -23326.25)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M1.747,4.5a.742.742,0,0,1-.53-.22l-1-1a.75.75,0,1,1,1.06-1.06l.47.47L4.217.218a.75.75,0,1,1,1.06,1.06l-3,3A.742.742,0,0,1,1.747,4.5Z",
    transform: "translate(-15496.747 -23328.248)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M1.747,4.5a.742.742,0,0,1-.53-.22l-1-1a.75.75,0,0,1,1.06-1.06l.47.47L4.217.218a.75.75,0,0,1,1.06,1.06l-3,3A.742.742,0,0,1,1.747,4.5Z",
    transform: "translate(-15496.747 -23321.248)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M1.747,4.5a.742.742,0,0,1-.53-.22l-1-1a.75.75,0,1,1,1.06-1.06l.47.47L4.217.218a.75.75,0,0,1,1.06,1.06l-3,3A.742.742,0,0,1,1.747,4.5Z",
    transform: "translate(-15496.747 -23314.248)",
    fill: "#061133"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconValidatie);
export default __webpack_public_path__ + "static/media/Icon-validatie.c04c840c269f7131d148ab7f50ed1ba3.svg";
export { ForwardRef as ReactComponent };